import React from 'react';

export interface TelefonoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const TelefonoIcon: React.FC<TelefonoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M23.417 17.846v3.125a2.083 2.083 0 0 1-2.271 2.083 20.6 20.6 0 0 1-8.99-3.198 20.3 20.3 0 0 1-6.25-6.25 20.6 20.6 0 0 1-3.198-9.031 2.083 2.083 0 0 1 2.073-2.271h3.125A2.08 2.08 0 0 1 9.99 4.095c.132 1 .376 1.982.729 2.928a2.08 2.08 0 0 1-.469 2.197l-1.323 1.323a16.67 16.67 0 0 0 6.25 6.25l1.323-1.322a2.08 2.08 0 0 1 2.198-.47c.945.353 1.927.598 2.927.73a2.083 2.083 0 0 1 1.792 2.115"/>
    </svg>
  );
};

export default TelefonoIcon;
